'use client';
import { useEffect } from 'react';

import { useAccountContext } from '~context/account';
import { usePaywallContext } from '~context/paywall';

import { useNeedsToShowNeuronsPaywall } from './useNeedsToShowNeuronsPaywall';
import { useNeedsToShowPaywall } from './useNeedsToShowPaywall';

export const useShowPaywall = () => {
	const { openPaywall } = usePaywallContext();
	const { hasSubscription } = useAccountContext();

	const { paywallIntent, setNeedsToShowPaywall } = useNeedsToShowPaywall();
	const { neuronsPaywallIntent, setNeedsToShowNeuronsPaywall } =
		useNeedsToShowNeuronsPaywall();

	useEffect(() => {
		if (paywallIntent && !hasSubscription) {
			openPaywall({
				checkoutReason: paywallIntent.checkoutReason,
				prefer: 'subscription',
			})();
			setNeedsToShowPaywall(undefined);
		}

		if (neuronsPaywallIntent) {
			openPaywall({
				checkoutReason: neuronsPaywallIntent.checkoutReason,
				prefer: 'neurons',
			})();
			setNeedsToShowNeuronsPaywall(undefined);
		}
	}, [
		setNeedsToShowNeuronsPaywall,
		setNeedsToShowPaywall,
		hasSubscription,
		openPaywall,
		paywallIntent,
		neuronsPaywallIntent,
	]);
};

export const Paywall = () => {
	useShowPaywall();
	return null;
};
